import { EColors, EFonts } from 'libs/styles/styling';
import React from 'react';
import styled from 'styled-components/macro';

interface Props {
    value: React.ReactNode;
    className?: string;
}

export const TextValuePreview = (props: Props): JSX.Element => {
    return (
        <S_TextValuePreview className={props.className}>{props.value ?? '-'}</S_TextValuePreview>
    );
};

const S_TextValuePreview = styled.div`
    font-size: 13px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Regular};
    padding: 15px 15px;
    border-bottom: 1px solid #dadada;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
`;
